export default __webpack_public_path__ + "static/media/refreshIcon.f772bb00.svg";